import { useScrollToHash } from 'hooks';

const ScrollToHashElement = () => {
  useScrollToHash();
  return null;
};

export default ScrollToHashElement;
